// extracted by mini-css-extract-plugin
export default {"Pagination":"Pagination_Pagination__Q21UD","select":"Pagination_select__CIqbg","site":"Pagination_site__xRrLo"};